module.exports = __webpack_public_path__ + "static/feature-phone-2-8d19ebeaa25a04e05ef22cbdd7cbada2.png";